import styled from "styled-components";

export const HomeProductContainer = styled.div`
  height: auto;
  padding: 0px;
  flex-shrink: 0;
  border-radius: 10px;

  @media only screen and (max-width: 767px) {
    overflow-x: auto;
    display: flex;
    padding: 0px;
    margin: 0px;
  }
`;

export const HomeProductWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 0px;
  margin: 0px;
`;

export const HomeProductCard = styled.div`
  width: 100%;
  display: flex;
  gap: 30px 0px;
  flex-wrap: wrap;

  @media only screen and (max-width: 767px) {
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 10px;
  }
`;

export const HomeProductMapped = styled.div<{ length: number }>`
  width: ${({ length }) => (length > 50 ? "30%" : "calc(30% - 15px)")};
  border-radius: 10px;
  box-shadow: 0px 4px 4px 0px rgba(234, 234, 234, 0.25);

  @media only screen and (max-width: 767px) {
    width: auto;
    flex: 0 0 auto;
  }
`;

export const HomeProductHeader = styled.div`
  padding: 0px;
`;

export const HomeProductHeaderText = styled.div`
  font-family: GT Walsheim Pro;
  font-size: 18px;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: 0.02em;
  text-align: left;
  color: #09005b;
  padding: 10px 0px 0px 20px;

  @media only screen and (max-width: 767px) {
    padding: 10px;
  }
`;

export const HomeProductCardContainer = styled.div`
  padding-left: 20px;

  @media only screen and (max-width: 767px) {
    overflow-x: auto;
    display: flex;
    padding-left: 10px;
  }
`;

export const HomeProductBeneathText = styled.div``;
export const HomeProductButtonContainer = styled.div``;

export const HomeProductCardImg = styled.div``;
export const HomeProductCardWrapper = styled.div``;
export const HomeProductCardP01 = styled.div``;
export const HomeProductCardP02 = styled.div``;

export const Container = styled.section`
  padding: 20px;
`;
